import Dropdown from 'react-bootstrap/Dropdown';
import DownArrow from '@/assets/img/down-arrow.svg';
import { ReactElement, useEffect, useRef, useState } from 'react';
import ListCheck from '@/assets/img/list-check-icon.svg';
export type DropDownItem = {
  label: string;
  value: any;
  isSelected?: boolean;
};
export type DropDownProps = {
  data: DropDownItem[] | any[];
  selectedValue?: any;
  placeholder?: string;
  onDismiss: () => void;
  onSelect: (selectedValue: any) => any;
  enableSearch?: boolean;
  icon?: string | ReactElement;
  isDisabled?: boolean;
  setObject?: boolean;
  customToggleClass?: string;
  labelKey?: string;
  valueKey?: string;
  mainClassName?: string;
  displayLabel?: string;
  customClass?: string;
  formatter?: (label: string, tz?: string) => void;
  formatterData?: string;
};
export const DropDown = ({
  data,
  selectedValue,
  placeholder,
  onDismiss,
  onSelect,
  icon,
  enableSearch,
  isDisabled,
  setObject,
  customToggleClass,
  mainClassName,
  displayLabel,
  valueKey,
  labelKey,
  customClass,
  formatter,
  formatterData,
}: DropDownProps) => {
  const inputRef: any = useRef(null);
  const [searchTerm, setSearchTerm] = useState<string>('');

  useEffect(() => {}, []);
  const handleSearchChange = (e: any) => {
    setSearchTerm(e.target.value);
  };
  const onDropdownToggle = () => {
    if (inputRef.current) {
      setTimeout(() => {
        inputRef.current.focus();
      }, 500);
    }
    const scroller = document.getElementById('dd-menu-scroll');
    scroller?.scrollTo(0, 0);
    setSearchTerm('');
  };
  const displaySelectedLabel = selectedValue
    ? valueKey && labelKey
      ? data.find((d) => d[valueKey] === selectedValue)?.[labelKey]
      : data.find((d) => d?.value === selectedValue)?.label
    : '';

  const filteredOptions = data.filter((d) =>
    labelKey
      ? d[labelKey]?.toLowerCase().indexOf(searchTerm.toLowerCase()) >= 0
      : d?.label?.toLowerCase().indexOf(searchTerm.toLowerCase()) >= 0
  );
  return (
    <Dropdown
      className={`${mainClassName ? mainClassName : 'new-figma-drop-down custom'} ${
        isDisabled ? 'disabled' : ''
      }`}
      onToggle={onDropdownToggle}
    >
      <Dropdown.Toggle
        variant="success"
        id="dropdown-basic"
        className={`drop-down-btn ${customToggleClass}`}
        disabled={isDisabled}
      >
        <div
          className={`btn-selected-text ${
            displayLabel || displaySelectedLabel ? '' : 'placeholder-text'
          }`}
        >
          {displayLabel
            ? displayLabel
            : displaySelectedLabel
            ? formatter
              ? formatter(displaySelectedLabel, formatterData)
              : displaySelectedLabel
            : placeholder
            ? placeholder
            : 'Select'}
        </div>
        <img src={DownArrow} className="down-arrow" />
      </Dropdown.Toggle>
      <Dropdown.Menu className={`${enableSearch ? 'search' : ''}`}>
        {enableSearch && (
          <div
            className="dropdown-item search"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
          >
            <input
              ref={inputRef}
              type="text"
              className="form-control mb-2"
              placeholder="Search..."
              value={searchTerm}
              autoFocus
              onChange={handleSearchChange}
            />
          </div>
        )}
        <div id="dd-menu-scroll" className="menu-scroller">
          {filteredOptions?.map((item, index) => {
            const labelValue = labelKey ? item[labelKey] : item?.label;
            return (
              <Dropdown.Item
                key={index}
                onClick={() => {
                  onSelect(setObject ? item : item.value);
                }}
                eventKey={item.value}
              >
                <div className="menu-item-minutes">
                  {formatter ? formatter(labelValue, formatterData) : labelValue}
                  {selectedValue ? (
                    valueKey ? (
                      selectedValue == item[valueKey] ? (
                        <img src={ListCheck} className="ListCheck" />
                      ) : null
                    ) : selectedValue == item.value ? (
                      <img src={ListCheck} className="ListCheck" />
                    ) : null
                  ) : null}
                </div>
              </Dropdown.Item>
            );
          })}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};
